import { useCallback, useState, useEffect } from 'react';

export interface IUseSingleToolNavigationHook {
  mobileNavTitle: string;
  isMobileNavVisible: boolean;
  isSearchVisible: boolean;
  isSearchActive: boolean;
  toggleNavigation: () => void;
  changeMenu: (name: string) => void;
  showSearch: () => void;
  navToNextMenu: (name: string) => void;
  navToPrevMenu: () => void;
  currentMenu: string;
  currentCategory: string;
}

function useSingleToolNavigationHook(): IUseSingleToolNavigationHook {
  const [mobileNavTitle, setMobileNavTitle] = useState<string>('Menu');
  const [isMobileNavVisible, setIsMobileNavVisible] = useState<boolean>(false);
  const [isSearchVisible, setIsSearchVisible] = useState<boolean>(false);
  const [isSearchActive, setSearchActive] = useState<boolean>(false);
  const [currentPath, setCurrentPath] = useState(['Menu']);
  const [currentMenu, setCurrentMenu] = useState('Menu');
  const [currentCategory, setCurrentCategory] = useState('');

  useEffect(() => {
    setCurrentMenu(currentPath[currentPath.length - 1]);
    setCurrentCategory(currentPath[1] || '');
    setMobileNavTitle(currentPath[currentPath.length - 1]);
  }, [currentPath]);

  const navToNextMenu = useCallback(
    (name: string) => setCurrentPath([...currentPath, name]),
    [currentPath],
  );

  const navToPrevMenu = useCallback(() => {
    if (isSearchVisible) {
      setMobileNavTitle(currentPath[currentPath.length - 1]);
      setIsSearchVisible(false);
    } else {
      setCurrentPath([...currentPath].slice(0, -1));
    }
  }, [currentPath, isSearchVisible]);

  const changeMenu = useCallback((name: string) => {
    setMobileNavTitle(name);
  }, []);

  const toggleNavigation = useCallback(() => {
    setMobileNavTitle('Menu');
    setIsMobileNavVisible((visible) => !visible);
  }, []);

  const showSearch = useCallback(() => {
    setIsSearchVisible(true);
    setMobileNavTitle('Search');
  }, []);

  useEffect(() => {
    setSearchActive(isSearchVisible);
  }, [isSearchVisible]);

  return {
    mobileNavTitle,
    isMobileNavVisible,
    isSearchVisible,
    isSearchActive,
    changeMenu,
    toggleNavigation,
    showSearch,
    navToNextMenu,
    navToPrevMenu,
    currentMenu,
    currentCategory,
  };
}

export default useSingleToolNavigationHook;
